"use client";

import Pusher from "pusher-js";

// Singleton Pusher client instance
let pusherClient: Pusher | null = null;

/**
 * Get or create Pusher client instance
 */
export function getPusherClient(): Pusher {
  if (!pusherClient) {
    pusherClient = new Pusher(process.env.NEXT_PUBLIC_PUSHER_KEY!, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER!,
      authEndpoint: "/api/pusher/auth",
      auth: {
        headers: {
          "Content-Type": "application/json",
        },
      },
    });
  }

  return pusherClient;
}

/**
 * Disconnect Pusher client
 */
export function disconnectPusher() {
  if (pusherClient) {
    pusherClient.disconnect();
    pusherClient = null;
  }
}
